import React, { useEffect, useRef, useState } from 'react';
import styles from './UploadFile.module.scss';
import cx from 'classnames';

function UploadFileWrapper({ children, fullWidth, hidden }) {
  const wrapperRef = useRef();
  const [windowSize, setWindowSize] = useState({ width: 1920, height: 1080 });

  const handleResize = () => {
    setWindowSize({
      width: wrapperRef.current?.parentNode.offsetWidth,
      height: wrapperRef.current?.parentNode.offsetHeight,
    });
  };

  useEffect(() => {
    setWindowSize({
      width: wrapperRef?.current?.parentNode.offsetWidth,
      height: wrapperRef?.current?.parentNode.offsetHeight,
    });

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return !hidden ? (
    <div
      ref={wrapperRef}
      className={!fullWidth ? cx(styles.variant2Box, styles.uploadWrapper) : 'w-100'}
      // style={!fullWidth ? { height: `${windowSize.width * 0.30835}px` } : {}}
    >
      {children}
    </div>
  ) : null;
}

export default UploadFileWrapper;
